import { render, staticRenderFns } from "./DiaryLikesNotification.vue?vue&type=template&id=d0abe454"
import script from "./DiaryLikesNotification.vue?vue&type=script&lang=js"
export * from "./DiaryLikesNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports